import React, {Component} from 'react';
import Inicio from '../LandingPage/LandingSubcomponents/Inicio';
import Servicios from '../LandingPage/LandingSubcomponents/Servicios';
import Marcas from '../LandingPage/LandingSubcomponents/Marcas';
import QuienesSomos from '../LandingPage/LandingSubcomponents/QuienesSomos';
import Contacto from '../LandingPage/LandingSubcomponents/Contacto';
import NavBarMenu from "../../layout/NavBar/NavBarMenu";
import MapaClientes from "./LandingSubcomponents/MapaClientes";
import NavSocial from "../../layout/NavSocial/NavSocial";
import BannerRRHH from "../RRHHPage/BannerRRHH";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom'

import axios from 'axios';
import c from '../../Constants';

import {fetchPromocionesIfNeeded} from "../../actions/PromocionesActions";
import PedidosOnline from "./LandingSubcomponents/Servicios/PedidosOnline";
import ConsultasWhatsapp from "./LandingSubcomponents/Servicios/ConsultasWhatsapp";
import Promociones from "./LandingSubcomponents/Servicios/Promociones";
import Footer from "../../layout/Footer/Footer";

class LandingPage extends Component {
    constructor() {
        super();

        this.state = {
            promociones: []
        };
    }

    componentDidMount() {
        window.scroll(0, 0);

    };

    render() {
        return (
            <div>
                <NavBarMenu/>
                <Inicio/>
                <QuienesSomos/>
                <Marcas/>
                <PedidosOnline/>
                <ConsultasWhatsapp/>
                <Servicios/>
                <Promociones/>
                <MapaClientes/>
                <Contacto/>
                <BannerRRHH/>
                <NavSocial/>
                <Footer/>
            </div>
        );
    }
}



export default LandingPage;



// WEBPACK FOOTER //
// ./src/pages/LandingPage/LandingPage.js